import React, { useEffect } from 'react';

import axios, { AxiosRequestConfig } from 'axios';
import { useParams } from 'react-router-dom';

import { Alert, Box, CircularProgress, Typography } from '@mui/material';

import backgroundImage from '../../assets/sxa-login-bg.jpg';
import { Logo } from '../../components/fa-logo';
import { useAppSelector } from '../../redux-store/hooks';
import { RootState } from '../../redux-store/store';

export default function SALPRedirect() {
  const params = useParams();
  const [loadingText, setLoadingText] = React.useState<string | null>(null);
  const [error, setError] = React.useState<string | null>(null);
  const config: any = useAppSelector((state: RootState) => state.global.config);

  const salpCheck = () => {
    const { sessionid, partyid } = params;

    return new Promise((resolve, reject) => {
      if (!sessionid || !partyid) {
        setError('Missing Session or Party Id!');
        reject();
        return;
      }
      const axiosConfig: AxiosRequestConfig = {
        method: 'GET',
        url: `${config.baseURL}/order-management/salp-redirect?SessionId=${sessionid}&PartyId=${partyid}`,
      };
      axios(axiosConfig)
        .then((res: any) => {
          const redirectURL = new URL(res?.data?.RedirectUrl);
          window.location.href = redirectURL.href;
        })
        .catch((error) => {
          const message = error?.response?.data?.Message
            ? error?.response?.data?.Message
            : 'Error Retrieving Order';
          setError(message);
          reject();
        });
    });
  };

  useEffect(() => {
    (async function () {
      setLoadingText('Verifying Order Details');
      salpCheck()
        .then((url: any) => {
          setLoadingText('Redirecting...');
          const urlObject = new URL(url);
          setTimeout(() => {
            window.location.pathname = urlObject.pathname;
          }, 2000);
        })
        .catch(() => {
          return;
        });
    })();
  }, []);

  return (
    <Box
      sx={{
        background: `#BCCFE0 url(${backgroundImage}) center / cover no-repeat`,
        width: '100vw',
        height: '100vh',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}>
      <Box
        display='flex'
        justifyContent='center'
        alignItems='center'
        flexDirection='column'
        width='300px'
        height='350px'
        sx={{
          zIndex: 100,
          background: 'white',
          boxShadow: 3,
        }}>
        <Box textAlign={'center'}>
          <Logo />
        </Box>
        <Box width='100%' marginTop='10px'>
          <Box
            display='flex'
            flexDirection='column'
            alignItems='center'
            padding='10px'>
            {!error ? (
              <>
                <Typography variant='button'>{loadingText}</Typography>
                <CircularProgress />
              </>
            ) : (
              <Alert severity='error'>{error}</Alert>
            )}
          </Box>
        </Box>
      </Box>
    </Box>
  );
}
